import React, {Component} from 'react'
import {Input} from "antd"
import 'antd/lib/input/style/index.css'
import PropTypes from 'prop-types'

class FilterBarcode extends Component {
    _handleChange = (e) => {
        const {name, value} = e.target
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                [name]: value
            })
        }
    }

    render() {
        const {filters} = this.props
        const {barcode} = filters

        return (
            <div className="FilterOrderNumber mb-3 mr-3">
                <label className='font-weight-bold d-block'>Barcode</label>
                <Input name="barcode" value={barcode} onChange={this._handleChange} placeholder='Tìm kiếm barcode item' style={{width: 350}}/>
            </div>
        )
    }
}

FilterBarcode.propTypes = {
    filters: PropTypes.object.isRequired,
    onChangeFilters: PropTypes.func.isRequired
}

export default FilterBarcode